import React from 'react';
import { SproutIcon, ClockIcon, FlaskConicalIcon, SparklesIcon, HeartHandshakeIcon } from 'lucide-react';
import { benefits } from '../data/content';
import { SectionTitle } from './SectionTitle';
import { Reveal } from './Reveal';
const icons = [SproutIcon, ClockIcon, FlaskConicalIcon, SparklesIcon, HeartHandshakeIcon];
export function BenefitsSection() {
  return <section className="bg-night px-5 py-10" data-id="element-27" data-mp="3nmygmnpdrnw5">
      <SectionTitle data-id="element-28" data-mp="38qz8xe66nprj">Lo que lograrás con esta guía...</SectionTitle>

      <ul className="mt-6 space-y-3" data-id="element-29" data-mp="3dqveviyfxr9q">
        {benefits.map((benefit, i) => {
        const Icon = icons[i];
        return <li key={benefit} data-id="element-30" data-mp="2zs434371whor" data-mpi={i}>
              <Reveal delay={i * 80} data-id="element-31" data-mp="2zsx0weo17wur">
                <div className="flex items-start gap-4 rounded-xl border border-gold/30 px-5 py-6
                    bg-forest/50
                    transition-all duration-300 hover:border-gold active:border-gold hover:scale-[1.02] active:scale-[1.02]" data-id="element-32" data-mp="34qfdcf19cu7i">
                  <Icon aria-hidden="true" className="mt-0.5 h-6 w-6 shrink-0 text-gold" strokeWidth={1.6} data-id="element-33" data-mp="12yk569e7n7u1" />
                  <p className="font-sans text-[16px] leading-relaxed text-ivory" data-id="element-34" data-mp="2bdcq7g9739we">
                    {benefit}
                  </p>
                </div>
              </Reveal>
            </li>;
      })}
      </ul>
    </section>;
}